<script src="vehicle-details-form.component.ts"></script>
<nz-modal nzWidth="900px" [(nzVisible)]="isVisible" [nzTitle]="type === 'add' ? 'Add Vehicle' : 'Update Vehicle'" (nzOnCancel)="cancel()" (nzOnOk)="handleOk()">
  <ng-container *nzModalContent>
    <div>
      <form nz-form [formGroup]="vehicleForm" [nzLayout]="'vertical'">
        <div>
          <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
            <div>
              <nz-form-label nzRequired>Vehicle Model</nz-form-label>
              <nz-form-item>
                <nz-form-control [nzErrorTip]="modelError">
                  <input nz-input type="text" placeholder="Enter Model"
                         formControlName="vehicleModel"/>
                </nz-form-control>
                <ng-template #modelError>
                  <span *ngIf="formErrors.vehicleModel.required">Please enter vehicle model. </span>
                </ng-template>
              </nz-form-item>
            </div>
            <div>
              <nz-form-label nzRequired>Registration Number</nz-form-label>
              <nz-form-item>
                <nz-form-control [nzErrorTip]="regNoError">
                  <input nz-input type="text" placeholder="Enter Registration Number"
                         formControlName="registerNumber"/>
                </nz-form-control>
                <ng-template #regNoError>
                  <span *ngIf="formErrors.registerNumber.required">Please enter registration number. </span>
                </ng-template>
              </nz-form-item>
            </div>
            <div>
              <nz-form-label nzRequired>Year of Manufacture</nz-form-label>
              <nz-form-item>
                <nz-form-control [nzErrorTip]="yearError">
                  <nz-date-picker
                    class="w-full"
                    placeholder="Enter Date and Time"
                    nzMode="year"
                    formControlName="yearOfManufacture"></nz-date-picker>
                </nz-form-control>
                <ng-template #yearError>
                  <span *ngIf="formErrors.yearOfManufacture.required">Please enter year of manufacture. </span>
                </ng-template>
              </nz-form-item>
            </div>
          </div>
          <div class="grid md:grid-cols-4 lg:grid-cols-7 gap-3 content-end">
            <!--        Front image-->
            <div>
              <nz-upload *ngIf="!frontImage.attach"
                         [nzCustomRequest]="vehicleImageFrontOnUpload" [nzShowUploadList]="false" [nzMultiple]="true"
                         class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <div *ngIf="!frontLoading" class="hover:cursor-pointer">
                  <span style="font-size: 4rem; color: #a2a2a2" nz-icon nzType="file-image" nzTheme="outline"></span>
                </div>
                <p *ngIf="frontLoading" class="text-primary text-xs">Uploading...</p>
              </nz-upload>
              <div *ngIf="frontImage.attach" class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <img class="w-full h-40 xl:h-40" src="{{frontImage?.attach?.url}}" alt="">
              </div>
              <div class="flex justify-center mt-2">
                <span style="color: #a2a2a2" class="text-center">Front</span>
                <span *ngIf="frontImage.attach" style="" nz-icon nzType="close" nzTheme="outline"
                      class="hover:cursor-pointer text-sm"
                      (click)="removeVehiclePhoto('front')"></span></div>
            </div>

            <!--        Back image-->
            <div>
              <nz-upload *ngIf="!backImage.attach"
                         [nzCustomRequest]="vehicleImageBackOnUpload" [nzShowUploadList]="false" [nzMultiple]="true"
                         class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <div *ngIf="!backLoading" class="hover:cursor-pointer">
                  <span style="font-size: 4rem; color: #a2a2a2" nz-icon nzType="file-image" nzTheme="outline"></span>
                </div>
                <p *ngIf="backLoading" class="text-primary text-xs">Uploading...</p>
              </nz-upload>
              <div *ngIf="backImage.attach" class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <img class="w-full h-40 xl:h-40" src="{{backImage?.attach?.url}}" alt="">
              </div>
              <div class="flex justify-center mt-2">
                <span style="color: #a2a2a2" class="text-center">Back</span>
                <span *ngIf="backImage.attach" style="" nz-icon nzType="close" nzTheme="outline"
                      class="hover:cursor-pointer text-sm"
                      (click)="removeVehiclePhoto('back')"></span></div>
            </div>

            <!--        Left side image-->
            <div>
              <nz-upload *ngIf="!leftImage.attach"
                         [nzCustomRequest]="vehicleImageLeftOnUpload" [nzShowUploadList]="false" [nzMultiple]="true"
                         class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <div *ngIf="!leftLoading" class="hover:cursor-pointer">
                  <span style="font-size: 4rem; color: #a2a2a2" nz-icon nzType="file-image" nzTheme="outline"></span>
                </div>
                <p *ngIf="leftLoading" class="text-primary text-xs">Uploading...</p>
              </nz-upload>
              <div *ngIf="leftImage.attach" class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <img class="w-full h-40 xl:h-40" src="{{leftImage?.attach?.url}}" alt="">
              </div>
              <div class="flex justify-center mt-2">
                <span style="color: #a2a2a2" class="text-center">Left</span>
                <span *ngIf="leftImage.attach" style="" nz-icon nzType="close" nzTheme="outline"
                      class="hover:cursor-pointer text-sm"
                      (click)="removeVehiclePhoto('left')"></span></div>
            </div>

            <!--        Right side image-->
            <div>
              <nz-upload *ngIf="!rightImage.attach"
                         [nzCustomRequest]="vehicleImageRightOnUpload" [nzShowUploadList]="false" [nzMultiple]="true"
                         class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <div *ngIf="!rightLoading" class="hover:cursor-pointer">
                  <span style="font-size: 4rem; color: #a2a2a2" nz-icon nzType="file-image" nzTheme="outline"></span>
                </div>
                <p *ngIf="rightLoading" class="text-primary text-xs">Uploading...</p>
              </nz-upload>
              <div *ngIf="rightImage.attach" class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <img class="w-full h-40 xl:h-40" src="{{rightImage?.attach?.url}}" alt="">
              </div>
              <div class="flex justify-center mt-2">
                <span style="color: #a2a2a2" class="text-center">Right</span>
                <span *ngIf="rightImage.attach" style="" nz-icon nzType="close" nzTheme="outline"
                      class="hover:cursor-pointer text-sm"
                      (click)="removeVehiclePhoto('right')"></span></div>
            </div>

            <!--        Boot image-->
            <div>
              <nz-upload *ngIf="!bootImage.attach"
                         [nzCustomRequest]="vehicleImageBootOnUpload" [nzShowUploadList]="false" [nzMultiple]="true"
                         class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <div *ngIf="!bootLoading" class="hover:cursor-pointer">
                  <span style="font-size: 4rem; color: #a2a2a2" nz-icon nzType="file-image" nzTheme="outline"></span>
                </div>
                <p *ngIf="bootLoading" class="text-primary text-xs">Uploading...</p>
              </nz-upload>
              <div *ngIf="bootImage.attach" class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <img class="w-full h-40 xl:h-40" src="{{bootImage?.attach?.url}}" alt="">
              </div>
              <div class="flex justify-center mt-2">
                <span style="color: #a2a2a2" class="text-center">Boot</span>
                <span *ngIf="bootImage.attach" style="" nz-icon nzType="close" nzTheme="outline"
                      class="hover:cursor-pointer text-sm"
                      (click)="removeVehiclePhoto('boot')"></span></div>
            </div>

            <!--        Dashboard image-->
            <div>
              <nz-upload *ngIf="!dashboardImage.attach"
                         [nzCustomRequest]="vehicleImageDashboardOnUpload" [nzShowUploadList]="false"
                         [nzMultiple]="true"
                         class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <div *ngIf="!dashboardLoading" class="hover:cursor-pointer">
                  <span style="font-size: 4rem; color: #a2a2a2" nz-icon nzType="file-image" nzTheme="outline"></span>
                </div>
                <p *ngIf="dashboardLoading" class="text-primary text-xs">Uploading...</p>
              </nz-upload>
              <div *ngIf="dashboardImage.attach"
                   class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <img class="w-full h-40 xl:h-40" src="{{dashboardImage?.attach?.url}}" alt="">
              </div>
              <div class="flex justify-center mt-2">
                <span style="color: #a2a2a2" class="text-center">Dashboard</span>
                <span *ngIf="dashboardImage.attach" style="" nz-icon nzType="close" nzTheme="outline"
                      class="hover:cursor-pointer text-sm"
                      (click)="removeVehiclePhoto('dashboard')"></span></div>
            </div>

            <!--        Interior image-->
            <div>
              <nz-upload *ngIf="!interiorImage.attach"
                         [nzCustomRequest]="vehicleImageInteriorOnUpload" [nzShowUploadList]="false" [nzMultiple]="true"
                         class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <div *ngIf="!interiorLoading" class="hover:cursor-pointer">
                  <span style="font-size: 4rem; color: #a2a2a2" nz-icon nzType="file-image" nzTheme="outline"></span>
                </div>
                <p *ngIf="interiorLoading" class="text-primary text-xs">Uploading...</p>
              </nz-upload>
              <div *ngIf="interiorImage.attach"
                   class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">
                <img class="w-full h-40 xl:h-40" src="{{interiorImage?.attach?.url}}" alt="">
              </div>
              <div class="flex justify-center mt-2">
                <span style="color: #a2a2a2" class="text-center">Interior Rear</span>
                <span *ngIf="interiorImage.attach" style="" nz-icon nzType="close" nzTheme="outline"
                      class="hover:cursor-pointer text-sm"
                      (click)="removeVehiclePhoto('interior rear')"></span></div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-container>
  <ng-container *nzModalFooter>
    <div class="flex justify-end sm:justify-end">
      <a
        nz-popconfirm
        nzPopconfirmTitle="Are you sure you want to cancel this record? you will loose all data."
        nzPopconfirmPlacement="bottom"
        (nzOnConfirm)="cancelConfirm()"
        (nzOnCancel)="cancel()"
      >
        <button class="outline-button mr-3" nz-button nzType="default">Cancel</button>
      </a>
      <button
        nz-popconfirm
        nzPopconfirmTitle="Are you sure you want to save the data?"
        nzPopconfirmPlacement="bottom"
        nz-button nzType="primary"
        (nzOnConfirm)="onSubmit()" (nzOnCancel)="cancel()" [disabled]="vehicleForm.invalid">Update Vehicle
      </button>
    </div>
  </ng-container>
</nz-modal>
